var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"city-name",on:{"click":function () { _vm.showCitySelect = true }}},[_vm._v(" "+_vm._s(_vm.cityInBefore)+" "),_c('span',{staticClass:"city-name__arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }